
import {Component, Vue} from 'vue-property-decorator';
import PersistentDialog from "@aprocon-software/aprocon-main-components";

@Component({
    components: {
        PersistentDialog
    },
})
export default class App extends Vue {

    private updateLogout() {
        this.showLogout = this.$store.getters["Base/qrCodeImage"] !== "";
    }
    private showLogout:boolean= false;
    private logOut(){
        this.$store.commit("Base/setQrCodeImage","");
        this.$router.go(0);
    }
    private footerCopyright:string ="";
    private logoPath:string="";
    private setCustomizedBase(args:{logoUrl:string, footerCopyright:string, colors?:any}) {
        this.logoPath = args.logoUrl || "../img/aprocon_logo-30.png";
        this.footerCopyright = args.footerCopyright || "Copyright 2024 APRO.CON Software GmbH & Co. KG";
        this.applyColors(args.colors);
    }

    private customBackground:string = "";
    private customText:string = "";
    private customButtonText:string = "";

    private isValidColor(value:any):boolean {
        return typeof value === "string" && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value);
    }

    private readColor(colors:any, key:string):string {
        const value = colors[key];
        if (value === undefined || value === null || value === "") {
            return "";
        }
        if (!this.isValidColor(value)) {
            console.warn(`customized.json: colors.${key} ungültig, erwartet #RGB oder #RRGGBB`);
            return "";
        }
        return value;
    }

    private applyColors(colors:any):void {
        if (!colors || typeof colors !== "object") {
            colors = {};
        }
        const button = this.readColor(colors, "button");
        if (button) {
            const themes = this.$vuetify.theme.themes;
            themes.light.primary = button;
            themes.light.info = button;
            themes.dark.primary = button;
            themes.dark.info = button;
        }
        this.customBackground = this.readColor(colors, "background");
        this.customText = this.readColor(colors, "text");
        this.customButtonText = this.readColor(colors, "buttonText");
    }

    private get appStyle():any {
        const style:any = {};
        if (this.customBackground) {
            style.backgroundColor = this.customBackground;
        }
        if (this.customText) {
            style["--cu-text"] = this.customText;
        }
        if (this.customButtonText) {
            style["--cu-button-text"] = this.customButtonText;
        }
        return style;
    }

    private get appClass():any {
        return {
            "cu-custom-text": !!this.customText,
            "cu-custom-button-text": !!this.customButtonText,
        };
    }

    mounted(){
        this.updateLogout();
    }
}
